module.exports = __webpack_public_path__ + "img/gold_badge_h80.e451845e.png";